import ButtonIconAdd from '../../../../../components/buttons/ButtonIconAdd';
import CustomTooltip from '../../../../../components/CustomTooltip';
import { Allergens, Diets } from '../../../../../enums/FoodieIcons';
import { AddIcon } from '../../../../../components/buttons/IconButtons';
import renderTooltipContent from './renderTooltipContent.jsx';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
// Function to render allergen and diet type icons with tooltips
const renderAllergenIcons = (item, t, showAll = false) => {
    const combined = [];
    // Add allergen icons (if any) to the combined list
    if (Array.isArray(item.allergenIds)) {
        item.allergenIds.forEach((id) => {
            const allergen = Allergens[id];
            if (allergen?.icon) {
                combined.push({
                    id: `allergen-${id}`,
                    Icon: allergen.icon,
                    name: allergen.name,
                });
            }
        });
    }
    // Add diet type icons (if any) to the combined list
    if (Array.isArray(item.dietTypeIds)) {
        item.dietTypeIds.forEach((id) => {
            const diet = Diets[id];
            if (diet?.icon) {
                combined.push({
                    id: `diet-${id}`,
                    Icon: diet.icon,
                    name: diet.name,
                });
            }
        });
    }
    // Show up to 4 icons directly
    const VISIBLE_LIMIT = 5;
    const visibleIcons = showAll ? combined : combined.slice(0, VISIBLE_LIMIT);
    // Remaining icons will be hidden and shown in a tooltip
    const hiddenIcons = showAll ? [] : combined.slice(VISIBLE_LIMIT);
    // Generate the translated tooltip text for the hidden icons
    let hiddenNamesTranslated = '';
    if (hiddenIcons.length > 10) {
        // If there are more than 10 hidden icons, show only the first 8 names
        const shown = hiddenIcons.slice(0, 9).map((el) => t(el.name));
        const extraCount = hiddenIcons.length - 9;
        hiddenNamesTranslated = `${shown.join('\n')}\n+${extraCount}`;
    } else {
        // If 10 or fewer, show all names translated
        hiddenNamesTranslated = hiddenIcons.map((el) => t(el.name)).join('\n');
    }

    return (
        <div className={`allergen-icons mt-2 ${showAll ? 'allergen-grid-5' : ''}`}>
            {visibleIcons.map(({ id, Icon, name }) => (
                <CustomTooltip key={id} text={t(name)}>
                    <Icon className='allergen-icon' />
                </CustomTooltip>
            ))}

            {hiddenIcons.length > 0 && (
                <ButtonIconAdd
                    Icon={AddIcon}
                    className='btn-outlined-secondary-500-600'
                    tooltipPlacement='bottom'
                    iconProps='btn-icon-svg-12px icon-color-general-00'
                    renderTooltipContent={renderTooltipContent(hiddenNamesTranslated, t)}
                />
            )}
        </div>
    );
};
export default renderAllergenIcons;
